import { z } from 'zod'

const toDate = (val: unknown) => {
  if (typeof val === 'object' && val !== null && 'toDate' in val && typeof val.toDate === 'function') {
    return (val as { toDate: () => Date }).toDate()
  }
  return val
}

export const DateZod = z.preprocess(toDate, z.date())
